<template>
    <div>
        <kinesis-container event="scroll"  style="overflow-x: hidden; width:100%; height: 100vh; position: absolute; top: 0; left: 0px">
            <kinesis-element 
            :strength="400" id="scrollBG" class="d-block d-lg-none"  style="position: absolute; top:0; left: -400px; height:90vh; width: calc(100% + 800px); " 
            :style="`background: url(${imgs.bg});  background-repeat-y: no-repeat; background-size: cover;  opacity: 0.6;`" 
            :distance="500" 
            type="translate" axis="x">
            </kinesis-element>
            
        </kinesis-container>
        
        <kinesis-container style="overflow-x: hidden">
            <kinesis-element 
            :strength="100" class="d-none d-lg-block"  style="position: absolute; top:0; left: -100px; height:100vh; width: calc(100% + 800px); z-index:-1" 
            :style="`background: url(${imgs.bg});  background-repeat-y: no-repeat; opacity: 0.6;`" 
            :distance="500" 
            type="translate" axis="x">
            </kinesis-element>
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 mb-5 text-left">
                        <div class="title-game mt-5 pt-lg-5">Descubre la Eurocidade<br/>con Chavín</div>
                        <span class="title-game-pr">Conheça a Eurocidade<br/>com Chavín</span>
                        <kinesis-element 
                        :strength="50" class="d-none d-lg-block"  tag="img" style="position: absolute; left: 15px; margin-top:50px;"
                        :distance="400" :src="imgs.chavin1" 
                        type="translate" axis="x,y">
                        </kinesis-element>

                        <kinesis-element 
                        :strength="10"  class="d-none d-lg-block" tag="img" style="position: absolute; left: 200px; margin-top:150px;"
                        :distance="300" :src="imgs.enemy1" 
                        type="translate" axis="x,y">
                        </kinesis-element>

                        <kinesis-element 
                        :strength="6"  class="d-none d-lg-block" tag="img" style="position: absolute; left: 300px; margin-top:150px;"
                        :distance="200" :src="imgs.enemy2" 
                        type="translate" axis="x,y">
                        </kinesis-element>

                        <kinesis-element 
                        :strength="11"  class="d-none d-lg-block" tag="img" style="position: absolute; left: 400px; margin-top:150px;"
                        :distance="500" :src="imgs.enemy3" 
                        type="translate" axis="x,y">
                        </kinesis-element>
                        
                        <kinesis-element 
                        :strength="11"  class="d-none d-lg-block" tag="img" style="position: absolute; left: 500px; margin-top:150px;"
                        :distance="500" :src="imgs.enemy4" 
                        type="translate" axis="x,y">
                        </kinesis-element>
                    </div>
                    <div class="vue-tempalte col-lg-5 pt-5 mt-lg-5" id="form-signup">
                        <kinesis-container id="scrollChars" event="scroll" class="d-block d-lg-none" style="overflow-x: hidden; width:100%;">
                                <kinesis-element 
                                :strength="90" class=""  tag="img" style="position: absolute; left: 15px; bottom: 10px; width: 5rem;"
                                :distance="400" :src="imgs.chavin1" 
                                type="translate" axis="x">
                                </kinesis-element>
                                <kinesis-element 
                                :strength="80"  class="" tag="img" style="position: absolute; left: 8rem;  bottom: 10px;  width: 4rem;"
                                :distance="300" :src="imgs.enemy1" 
                                type="translate" axis="x">
                                </kinesis-element>

                                <kinesis-element 
                                :strength="60"  class="" tag="img" style="position: absolute; left: 13rem;  bottom: 10px;  width: 4rem;"
                                :distance="200" :src="imgs.enemy2" 
                                type="translate" axis="x">
                                </kinesis-element>

                                <kinesis-element 
                                :strength="70"  class="" tag="img" style="position: absolute; left: 18rem;  bottom: 10px; width: 4rem;"
                                :distance="500" :src="imgs.enemy3" 
                                type="translate" axis="x">
                                </kinesis-element>
                                
                                <kinesis-element 
                                :strength="69"  class="" tag="img" style="position: absolute; left: 23rem;  bottom: 10px; width: 4rem;"
                                :distance="500" :src="imgs.enemy4" 
                                type="translate" axis="x">
                                </kinesis-element>
                            </kinesis-container>
                        <div class="card mt-lg-5 rounded shadow-sm bg-white border-light">
                            
                            <div class="card-body">
                                <form  @submit="submitForm" >
                                    <h3>¡Identifícate y juega!</h3>
                                    <div class="form-group">
                                        <label>Nombre</label>
                                        <input v-model="form.name" type="text" class="form-control form-control-lg" required/>
                                    </div>
                                    <div class="form-group">
                                        <label>Email (opcional)</label>
                                        <input v-model="form.email" type="email" class="form-control form-control-lg"/>
                                    </div>
                                    <div class="form-group">
                                        <label>Edad</label>
                                        <select v-model="form.age" class="form-control form-control-lg" required>
                                            <option v-for="n in 90" :key="n">{{ n + 2}} años</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Nacionalidad</label>
                                        <select v-model="form.country" type="text" class="form-control form-control-lg" required>
                                            <option disabled value="">Selecciona</option>
                                            <option value="España">España</option>
                                            <option value="Portugal">Portugal</option>
                                        </select>
                                    </div>
                                    <div class="form-check">
                                        <input type="checkbox" id="acceptLegalBox" class="form-check-input" required/>
                                        <label for="acceptLegalBox">He leído y acepto la <a href="#legal">Política de privacidad</a></label>
                                    </div>
                                    <button type="submit" class="btn btn-primary btn-lg btn-block mb-2">¡Jugar!</button>
                                    
                                    

                                    <p class="forgot-password text-left mb-5 ">
                                        Aprende a jugar <a target="_blank" href="https://crossbordergames.eu/manual_es.pdf">Aquí</a> | 
                                        aprenda a jogar <a target="_blank" href="https://crossbordergames.eu/manual_pt.pdf">Aqui</a>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5">
                    <article id="legal" class="legal">
                        <p>Le informamos que todos los datos personales facilitados a Eurocidade Chaves-Verín, AECT serán tratados con absoluta confidencialidad bajo nuestra responsabilidad, con la finalidad de la utilización exclusiva del juego. Los datos proporcionados se conservarán mientras se mantenga la relación de la utilización exclusiva del juego. o durante los años necesarios para cumplir con las obligaciones legales. Puede ejercer sus derechos de acceso, rectificación, supresión y portabilidad de sus datos, de limitación y oposición a su tratamiento, así como a no ser objeto de decisiones basadas únicamente en el tratamiento automatizado de sus datos, cuando procedan, ante  Eurocidade Chaves-Verín, AECT a través de info@eurocidadechavesverin.eu o la dirección Edifc. Antigua Aduana,  Avda. Portugal, s/n. Feces de Abaixo  32699 Verín (Ourense)
                        Tiene derecho a presentar una reclamación ante la Autoridad de Control (Agencia Española de Protección de Datos www.aepd.es)
                        Información adicional: Puede consultar la información adicional y detallada sobre Protección de datos en nuestra política de privacidad: info@eurocidadechavesverin.eu
                        </p><p>
                        Informamos que todos os dados pessoais fornecidos serão tratados com absoluta confidencialidade sob a responsabilidade da Eurocidade Chaves-Verín, AECT, com o propósito de utilizá-los para o uso exclusivo do jogo.
                        Os dados fornecidos serão mantidos enquanto o uso exclusivo do jogo. Terá o direito de obter confirmação sobre se na Eurocidade Chaves-Verín, AECT está a tratando seus dados pessoais, portanto, tem o direito de aceder aos seus dados pessoais, retificar os dados imprecisos ou solicitar sua exclusão quando os dados não forem mais necessários, ou limitar o seu tratamento, ou para se opor ao tratamento, bem como o direito de portabilidade dos dados, contactando a Eurocidade Chaves-Verín, AECT através do endereço info@eurocidadechavesverin.eu ou a direção Edifc. Antigua Aduana, Avda. Portugal, s / n. Feces de Abaixo 32699 Verín (Ourense) España.
                        Tem o direito de apresentar uma reclamação junto à Autoridade de Controle (Agência Espanhola de Proteção de Dados www.aepd.es).</p>

                    </article>
                </div>
            </div>
        </kinesis-container>
        
    </div>
</template>

<script>
    import { KinesisContainer, KinesisElement} from 'vue-kinesis'
    export default {
        data() {
            return {
                imgs: {
                    chavin1:  require('@/assets/images/chavin_1.png'),
                    chavin2:  require('@/assets/images/chavin_2.png'),
                    enemy1:  require('@/assets/images/enemy_1.png'),
                    enemy2:  require('@/assets/images/enemy_2.png'),
                    enemy3:  require('@/assets/images/enemy_3.png'),
                    enemy4:  require('@/assets/images/enemy_4.png'),
                    bg:  require('@/assets/images/fondo.png')
                },
                form: {
                    name: "",
                    email: "",
                    age: "",
                    country: ""
                }
            }
        },
        components: {KinesisContainer, KinesisElement},
        methods: {
            submitForm(e) {
                e.preventDefault();
                localStorage.setItem('player', JSON.stringify(this.form));
                this.getUserData(this.form);
                this.$router.push({ name: 'play' });
            },
            getUserData(form) {
                var data = JSON.stringify({
                    "first_name": form.name,
                    "last_name": "",
                    "email": form.email,
                    "age": form.age,
                    "country": form.country
                });
                try{
                    this.sendUserData(data);
                }
                catch(e) {
                    console.log(e);
                }
            },
            sendUserData(data) {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: data,
                redirect: 'follow',
                mode: 'no-cors'
                };

                fetch("/sendPost.php", requestOptions)
                .then(response => response.text())
                .then(result => console.log(result))
                .catch(error => console.log('error', error));
            },
            parallax() {
                // var scene = document.getElementById('scene');
                // var parallaxInstance = new Parallax(scene);
            },
            mounted() {
                this.parallax()
            }
        },
        mounted: function() {
            document.title = "Descubre la Eurocidade con Chavín."
        }
    }
</script>